import { AppState } from './app';
import * as constants from '../constants';
import { addToSSObject, getDataFromSSObject, replaceUmlauts, saveFullObjToSSObject } from '../utils/react';
import { Types } from '../actions/typeContainer';

// We type the payload cast inside each switch case:
export type AppUtilityActionType = {
  type:
    | typeof constants.LOCATION_CHANGE
    | typeof constants.CLEAR_DATA
    | typeof constants.SET_UI_DATA
    | typeof constants.PREFILL_DATA
    | typeof constants.SET_TYPE_CONTAINER
    | typeof constants.KEYCLOAK_STATE;
  payload: any;
};

export const appUtilitySchemaReducer = (state: AppState, action: AppUtilityActionType, getInitialState: () => any) => {
  switch (action.type) {
    case constants.LOCATION_CHANGE: {
      const urlHistory = [...state.urlHistory, action.payload.location.pathname];
      addToSSObject('ecState', 'urlHistory', urlHistory);
      return {
        ...state,
        urlHistory: urlHistory,
      };
    }

    case constants.CLEAR_DATA: {
      if (action.payload === 'start') {
        (window as any).sessionStorage.removeItem('userDataEC');
        (window as any).sessionStorage.removeItem('ecState');

        return {
          ...state,
          ...getInitialState(),
        };
      } else {
        return {
          ...state,
          userDataEC: {
            ...state.userDataEC,
            basketInfo: null,
          },
        };
      }
    }

    case constants.SET_UI_DATA: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          ui: {
            ...state.userDataEC.ui,
            ...action.payload,
          },
        },
      };
    }

    case constants.PREFILL_DATA: {
      const { availability, coordinate, industry } = action.payload.data;

      const locationsObj = {};

      if (!coordinate || !coordinate.length) {
        return {
          ...state,
        };
      }

      coordinate.forEach((loc) => {
        loc.address = loc.name;
        loc.lngLtd = {};
        loc.lngLtd.lng = loc.longitude;
        loc.lngLtd.lat = loc.latitude;
        locationsObj[replaceUmlauts(loc.name)] = loc;
      });

      const duration = availability && availability.duration ? availability.duration : 7;
      const code = industry && industry.code ? industry.code : undefined;

      const data = {
        duration,
        industry: code,
        locations: locationsObj, //TODO need check formats - expected [], needs {}
      };

      const ssUserData = getDataFromSSObject('userDataEC');

      saveFullObjToSSObject('userDataEC', { ...ssUserData, ...data });

      return {
        ...state,
        dataPrefilledJ3: true,
        userDataEC: { ...state.userDataEC, ...data },
      };
    }

    case constants.KEYCLOAK_STATE: {
      (window as any).keycloakReady =
        state.keycloakReducer.ready || (window as any).keycloakReadyDjango ? true : action.payload.event === 'onReady';
      const tokens = action.payload.tokens ||
        state.keycloakReducer.tokens || {
          idToken: (window as any).keycloak.idToken,
          refreshToken: (window as any).keycloak.refreshToken,
          token: (window as any).keycloak.token,
        };
      if (tokens.token && tokens.refreshToken) {
        (window as any).sessionStorage.setItem('bearerTokenEC', tokens.token);
        (window as any).sessionStorage.setItem('refreshTokenEC', tokens.refreshToken);
      }
      return {
        ...state,
        keycloakReducer: {
          ready:
            state.keycloakReducer.ready || (window as any).keycloakReadyDjango
              ? true
              : action.payload.event === 'onReady',
          tokens,
          lastEvent: action.payload.event ? action.payload.event : state.keycloakReducer.lastEvent,
        },
      };
    }

    case constants.SET_TYPE_CONTAINER: {
      const { type, url = '' } = action.payload;

      return {
        ...state,
        containers: {
          type,
          isJourney1: type === Types.journey1,
          isJourney2: type === Types.journey2,
          isJourney3: type === Types.journey3,
          url,
        },
      };
    }
  }
};
